import { Component, OnInit, Inject } from '@angular/core';
import {FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Utils from '../../utility';
import * as internal from 'events';

interface ROR{
  name: string;
  value: number;
}

@Component({
  selector: 'app-adjust-rates',
  templateUrl: './adjust-rates.component.html',
  styleUrls: ['./adjust-rates.component.css']
})

export class AdjustRatesComponent implements OnInit {
  
  adjustRatesForm: FormGroup;
  minYearOne;
  maxYear;
  data;
  rorOneList: Array<ROR> = [];
  rorTwoList: Array<ROR> = [];
  partnerName;
  phaseTwoStart;

  constructor(public dialogRef: MatDialogRef<AdjustRatesComponent>,
    @Inject(MAT_DIALOG_DATA) data) {
      console.log('Adjust Rates passed', data);
      this.data = data;
     }

/*   ngOnInit() {
    console.log('test 1');
    //set name to be displayed; if needed
    //this.partnerName = (this.data.client.clientProfile.Spouses.length > 0) ? ((this.data.client.clientProfile.Spouses[0].maritalStatus != 'Single') ? (((this.convertToYear(this.data.client.clientProfile.Spouses[0].dob, this.data.client.clientProfile.Spouses[0].retirementAge) > this.convertToYear(this.data.client.client.DOB, this.data.client.clientProfile.RetirementAge)) ? this.data.client.clientProfile.Spouses[0].firstName : this.data.client.client.FirstName)) : "") : "";
    this.partnerName = (this.data.client.clientProfile.Spouses.length > 0) ? ((this.data.client.clientProfile.Spouses[0].maritalStatus != 'Single') ? (((this.convertToYear(this.data.client.clientProfile.Spouses[0].dob, this.data.client.clientProfile.Spouses[0].LifeExpectancy) > this.convertToYear(this.data.client.client.DOB, this.data.client.clientProfile.LifeExpectancy)) ? this.data.client.clientProfile.Spouses[0].firstName : this.data.client.client.FirstName)) : "") : "";
    console.log('test 2');
    //set the min on year one
    this.minYearOne = (this.data.client.clientProfile.Spouses.length > 0) ? ((this.data.client.clientProfile.Spouses[0].maritalStatus == 'Single') ? this.convertToYear(this.data.client.client.DOB, this.data.client.clientProfile.RetirementAge) : ((this.convertToYear(this.data.client.clientProfile.Spouses[0].dob, this.data.client.clientProfile.Spouses[0].retirementAge) > this.convertToYear(this.data.client.client.DOB, this.data.client.clientProfile.RetirementAge)) ? this.convertToYear(this.data.client.clientProfile.Spouses[0].dob, this.data.client.clientProfile.Spouses[0].retirementAge) : this.convertToYear(this.data.client.client.DOB, this.data.client.clientProfile.RetirementAge))) : this.convertToYear(this.data.client.client.DOB, this.data.client.clientProfile.RetirementAge);
    console.log('test 3');
    this.maxYear = (this.data.client.clientProfile.Spouses.length > 0) ? ((this.data.client.clientProfile.Spouses[0].maritalStatus == 'Single') ? this.convertToYear(this.data.client.client.DOB, parseInt(this.data.client.clientProfile.LifeExpectancy)) : ((this.convertToYear(this.data.client.client.DOB, parseInt(this.data.client.clientProfile.LifeExpectancy)) > this.convertToYear(this.data.client.clientProfile.Spouses[0].dob, parseInt(this.data.client.clientProfile.Spouses[0].LifeExpectancy)) ? this.convertToYear(this.data.client.client.DOB, parseInt(this.data.client.clientProfile.LifeExpectancy)) : this.convertToYear(this.data.client.clientProfile.Spouses[0].dob, parseInt(this.data.client.clientProfile.Spouses[0].LifeExpectancy))))) : this.convertToYear(this.data.client.client.DOB, parseInt(this.data.client.clientProfile.LifeExpectancy));
    console.log('test 4');
    var yearDiff = ((this.maxYear - this.minYearOne) >= 10) ? 10 : ((this.maxYear - this.minYearOne) / 2);
    console.log('test 5');
    this.phaseTwoStart = parseInt(this.minYearOne + yearDiff);
    //create lists for dropdowns
    for(var i = this.minYearOne; i < this.maxYear; i++){
      
      if(i >= this.phaseTwoStart){
        this.rorTwoList.push({ name: "<b>" + i + " (" + ((this.data.client.clientProfile.Spouses.length == 0) ? parseInt(this.data.client.clientProfile.RetirementAge + (i - this.minYearOne)) : ((parseInt(this.data.client.clientProfile.RetirementAge + (i - this.minYearOne)) <= parseInt(this.data.client.clientProfile.LifeExpectancy)) ? parseInt(this.data.client.clientProfile.RetirementAge + (i - this.minYearOne)) : " -- ") + "/" + ((parseInt(this.data.client.clientProfile.Spouses[0].retirementAge) + (i - this.minYearOne)) <= parseInt(this.data.client.clientProfile.Spouses[0].LifeExpectancy) ? parseInt(this.data.client.clientProfile.Spouses[0].retirementAge) + (i - this.minYearOne) : " -- ")) + ")</b>", value: i});
      } else {
        var clientAge = (this.data.client.clientProfile.RetirementAge > this.convertDOBToAge(this.data.client.client.DOB)) ? this.data.client.clientProfile.RetirementAge : this.convertDOBToAge(this.data.client.client.DOB);
        //console.log('rate one', clientAge);
        
        this.rorOneList.push({ name: "<b>" + i + " (" + ((this.data.client.clientProfile.Spouses.length == 0) ? parseInt(clientAge + (i - this.minYearOne)) 
        : ((parseInt(clientAge + (i - this.minYearOne)) <= parseInt(this.data.client.clientProfile.LifeExpectancy)) 
        ? parseInt(clientAge + (i - this.minYearOne)) 
        : " -- ") + "/" + ((parseInt(this.data.client.clientProfile.Spouses[0].retirementAge) + (i - this.minYearOne)) <= parseInt(this.data.client.clientProfile.Spouses[0].LifeExpectancy) 
        ? parseInt(this.data.client.clientProfile.Spouses[0].retirementAge) + (i - this.minYearOne) : " -- ")) + ")</b>", value 
        : i});
      }
    }
    console.log('test 6');

    //if(this.data.obj)
    //set form with values
    this.adjustRatesForm = new FormGroup({
      
      rorOne: new FormControl((this.data.obj) ?  Utils.formatToPercentage(Utils.formatToDecimal(this.data.obj.rorOne)) : Utils.formatToPercentage(Utils.formatToDecimal(6)), [Validators.required, Validators.min(0), Validators.max(12)]),
      rorTwo: new FormControl((this.data.obj) ? Utils.formatToPercentage(Utils.formatToDecimal(this.data.obj.rorTwo)) : Utils.formatToPercentage(Utils.formatToDecimal(6)), [Validators.required, Validators.min(0), Validators.max(12)]),
      rorThree: new FormControl((this.data.obj) ? Utils.formatToPercentage(Utils.formatToDecimal(this.data.obj.rorThree)) : Utils.formatToPercentage(Utils.formatToDecimal(6)), [Validators.required, Validators.min(0), Validators.max(12)]),
      throughYearOne: new FormControl((this.data.obj) ? this.data.obj.throughYearOne : this.minYearOne),
      throughYearTwo: new FormControl((this.data.obj) ? this.data.obj.throughYearTwo : this.phaseTwoStart),
      throughYearThree: new FormControl(this.maxYear)
    });

    console.log('adjusted rates', this.adjustRatesForm.value);
  } */

ngOnInit() {
  // 1. Setup Data Shortcuts
  const clientData = this.data.client.client;
  const profile = this.data.client.clientProfile;
  const spouse = profile.Spouses[0];
  const hasSpouse = spouse && spouse.maritalStatus !== 'Single';

  // 2. Calculate Retirement Years
  const clientRetireYear = this.convertToYear(clientData.DOB, profile.RetirementAge);
  const clientEndYear = this.convertToYear(clientData.DOB, parseInt(profile.LifeExpectancy));

  if (hasSpouse) {
    const spouseRetireYear = this.convertToYear(spouse.dob, spouse.retirementAge);
    const spouseEndYear = this.convertToYear(spouse.dob, parseInt(spouse.LifeExpectancy));

    // PICK WHOEVER IS RETIRING FIRST
    if (clientRetireYear <= spouseRetireYear) {
      this.partnerName = clientData.FirstName;
      this.minYearOne = clientRetireYear;
    } else {
      this.partnerName = spouse.firstName;
      this.minYearOne = spouseRetireYear;
    }

    // Max Year is the latest life expectancy
    this.maxYear = Math.max(clientEndYear, spouseEndYear);
  } else {
    // Single Client Logic
    this.partnerName = clientData.FirstName;
    this.minYearOne = clientRetireYear;
    this.maxYear = clientEndYear;
  }

  // 3. Phase Calculations
  const diff = this.maxYear - this.minYearOne;
  const yearDiff = diff >= 10 ? 10 : Math.floor(diff / 2);
  this.phaseTwoStart = this.minYearOne + yearDiff;

  // 4. Populate Dropdown Lists
  //this.generateRateLists(profile, spouse, hasSpouse);
  const clientStartAge = Math.max(profile.RetirementAge, this.convertDOBToAge(this.data.client.client.DOB));

  for (let year = this.minYearOne; year < this.maxYear; year++) {
    const offset = year - this.minYearOne;
    
    // Calculate display ages
    const cAge = this.ageInYear(clientData.DOB, year);
    const sAge = hasSpouse ? this.ageInYear(spouse.dob, year) : null;

    // Formatting Logic
    const cDisplay = cAge <= parseInt(profile.LifeExpectancy) ? cAge : "--";
    const sDisplay = hasSpouse ? (sAge <= parseInt(spouse.LifeExpectancy) ? sAge : "--") : "";
    
    const label = `<b>${year} (${cDisplay}${hasSpouse ? '/' + sDisplay : ''})</b>`;
    const item = { name: label, value: year };

    if (year >= this.phaseTwoStart) {
      this.rorTwoList.push(item);
    } else {
      this.rorOneList.push(item);
    }
  }

  this.adjustRatesForm = new FormGroup({
      
      rorOne: new FormControl((this.data.obj) ?  Utils.formatToPercentage(Utils.formatToDecimal(this.data.obj.rorOne)) : Utils.formatToPercentage(Utils.formatToDecimal(6)), [Validators.required, Validators.min(0), Validators.max(12)]),
      rorTwo: new FormControl((this.data.obj) ? Utils.formatToPercentage(Utils.formatToDecimal(this.data.obj.rorTwo)) : Utils.formatToPercentage(Utils.formatToDecimal(6)), [Validators.required, Validators.min(0), Validators.max(12)]),
      rorThree: new FormControl((this.data.obj) ? Utils.formatToPercentage(Utils.formatToDecimal(this.data.obj.rorThree)) : Utils.formatToPercentage(Utils.formatToDecimal(6)), [Validators.required, Validators.min(0), Validators.max(12)]),
      throughYearOne: new FormControl((this.data.obj) ? this.data.obj.throughYearOne : this.minYearOne),
      throughYearTwo: new FormControl((this.data.obj) ? this.data.obj.throughYearTwo : this.phaseTwoStart),
      throughYearThree: new FormControl(this.maxYear)
    });
  
  // 5. Initialize Form (using similar logic to your original)
  //this.initForm();
}

  ageInYear(dob, year) {
    return this.convertDOBToAge(dob) + (year - new Date().getFullYear());
  }

  close(update): void {
    if(update){
      this.adjustRatesForm.controls['rorOne'].patchValue(Utils.removePercentageFormatting(this.adjustRatesForm.value.rorOne));
      this.adjustRatesForm.controls['rorTwo'].patchValue(Utils.removePercentageFormatting(this.adjustRatesForm.value.rorTwo));
      this.adjustRatesForm.controls['rorThree'].patchValue(Utils.removePercentageFormatting(this.adjustRatesForm.value.rorThree));
      console.log('adjusted rates', this.adjustRatesForm.value);
      this.dialogRef.close(this.adjustRatesForm.value);
    } else {
      this.dialogRef.close();
    }
  }

  convertToYear(currentAge, retirementAge){
    var date = new Date().getFullYear();
    return (retirementAge - this.convertDOBToAge(currentAge)) + date;
  }

  convertDOBToAge(dob){
    /* dob = new Date(dob);
    var ageDifMs = Date.now() - dob;
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970); */

    var bday = new Date(dob);
    var today = new Date();
    return today.getFullYear() - bday.getFullYear();
  }

  
  formatPercentage(event, scenario, precision = 2) {
    console.log('scenario', scenario);
    const key = event.keyCode || event.charCode;
    var value = event.target.value.replace('%', '');
    var values = value.split('.')
    const isNegative = value.substring(0, 1) === '-'
    console.log('value 01', value);

    if (!(/\d/.test(value)) && !isNegative) {
      console.log('value 02', value);
      value = ''
    } else {
      if(value.includes('.')) {
        console.log('value 03', value);
        values[0] = isNegative ? values[0].replace(/\D+/g, '') * -1 : values[0].replace(/\D+/g, '');
        values[1] = values[1].replace(/\D+/g, '');
        value = `${values[0]}.${values[1].substring(0, precision)}`
      } else {
        console.log('value 04', value);
        if (value < 0)
          value = value;
        else
          value = value === '-' ? '-' : value.replace(/\D+/g, '');
      }
    }
    
    var isDeleting = false;
    if (key === 8 || key === 46) {
      isDeleting = true;
    }
    console.log('value 05', value);

    if (value != '') {
      if (scenario == 'rorOne') {
        this.adjustRatesForm.controls['rorOne'].patchValue((isDeleting) ? value :Utils.formatToPercentage(Utils.formatToDecimal(value)));
      }
      if (scenario == 'rorTwo') {
        this.adjustRatesForm.controls['rorTwo'].patchValue((isDeleting) ? value :Utils.formatToPercentage(Utils.formatToDecimal(value)));
      }
      if (scenario == 'rorThree') {
        this.adjustRatesForm.controls['rorThree'].patchValue((isDeleting) ? value :Utils.formatToPercentage(Utils.formatToDecimal(value)));
      }
    }


  }
}
